$(document).ready(checkSizeLoad);
$(window).resize(function() {
   clearTimeout(window.resizedFinished);
   window.resizedFinished = setTimeout(function(){
      checkSizeReload();
   }, 100); 
});

//loads the labels for the colors after the PO app finished loading  if the page width is less than 767px
function checkSizeLoad() {
   if (window.innerWidth < 767) {
      document.querySelector('body').addEventListener("productOptionsLoadedJS", function(e) {
      var colors = document.querySelectorAll(".image-picker-item");
      for (i = 0; i < colors.length; ++i) {
         var name = colors[i].getAttribute('data-name');
         var newlabel = document.createElement("Label");
         newlabel.innerHTML = name;
         newlabel.classList.add("w3-color-label");
         colors[i].appendChild(newlabel);
      }
      });
   }
}

//Runs after the page is resized. Adds labels if page is less than 767px wide otherwise removes them 
function checkSizeReload() {
   var colors = document.querySelectorAll(".image-picker-item");
   for (i = 0; i < colors.length; ++i) {
      var name = colors[i].getAttribute('data-name');
      if (window.innerWidth < 767) {
         var extLabel = colors[i].querySelector('.w3-color-label');
         if (!extLabel){
            var newlabel = document.createElement("Label");
            newlabel.innerHTML = name;
            newlabel.classList.add("w3-color-label");
            colors[i].appendChild(newlabel);
         }
      }else{
         var extLabel = colors[i].querySelector('.w3-color-label');
         if(extLabel != null){
            extLabel.remove();
         }
      }

  }
}